module.exports = __webpack_public_path__ + "img/layout-wtf.e62dc450.svg";